import { useId } from "react";
export function useFieldIssueFrames(fieldIssues) {
    const messagesIdPrefix = useId();
    return (field)=>({
            messages: fieldIssues?.messages.get(field),
            focusRequestId: fieldIssues?.focus?.field === field ? fieldIssues.focus.id : undefined,
            onFocusHandled: fieldIssues?.onFocusHandled,
            messagesId: `${messagesIdPrefix}${field}`
        });
}
/** ARIA for a raw control inside `frame`; style it with `aria-invalid:`. */ export function invalidControlAria(frame) {
    if (!frame.messages?.length) return {};
    return {
        "aria-invalid": true,
        "aria-describedby": frame.messagesId
    };
}

//# sourceMappingURL=stepFieldIssues.js.map